import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const ServiceDetailPage = lazy(() => import('../pages/services/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const TeamPage = lazy(() => import('../pages/team/page'));
const TeacherDetailPage = lazy(() => import('../pages/teacher/page'));
const TeacherPage = lazy(() => import('../pages/teacher/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogDetailPage = lazy(() => import('../pages/blog-detail/page'));
const AdminLayout = lazy(() => import('../pages/admin/layout'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const AdminTeachers = lazy(() => import('../pages/admin/teachers/page'));
const AdminSliders = lazy(() => import('../pages/admin/sliders/page'));
const AdminInfoCards = lazy(() => import('../pages/admin/info-cards/page'));
const AdminTheme = lazy(() => import('../pages/admin/theme/page'));
const AdminMenu = lazy(() => import('../pages/admin/menu/page'));
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const AdminAbout = lazy(() => import('../pages/admin/about/page'));
const AdminServices = lazy(() => import('../pages/admin/services/page'));
const AdminGallery = lazy(() => import('../pages/admin/gallery/page'));
const AdminBlog = lazy(() => import('../pages/admin/blog/page'));
const AdminContact = lazy(() => import('../pages/admin/contact/page'));
const AdminSEO = lazy(() => import('../pages/admin/seo/page'));
const CategoryServicesPage = lazy(() => import('../pages/category-services/page'));
const AllServicesPage = lazy(() => import('../pages/all-services/page'));
const AdminMessages = lazy(() => import('../pages/admin/messages/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/hakkimizda',
    element: <AboutPage />,
  },
  {
    path: '/hizmetler',
    element: <AllServicesPage />,
  },
  {
    path: '/hizmetler/:categoryId',
    element: <CategoryServicesPage />,
  },
  {
    path: '/hizmetler/:slug',
    element: <CategoryServicesPage />,
  },
  {
    path: '/hizmet/:slug',
    element: <ServiceDetailPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/galeri',
    element: <GalleryPage />,
  },
  {
    path: '/iletisim',
    element: <ContactPage />,
  },
  {
    path: '/kadromuz',
    element: <TeamPage />,
  },
  {
    path: '/ekip/:id',
    element: <TeacherDetailPage />,
  },
  {
    path: '/kadromuz/:id',
    element: <TeacherPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogDetailPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      {
        index: true,
        element: <AdminDashboard />,
      },
      {
        path: 'dashboard',
        element: <AdminDashboard />,
      },
      {
        path: 'teachers',
        element: <AdminTeachers />,
      },
      {
        path: 'sliders',
        element: <AdminSliders />,
      },
      {
        path: 'info-cards',
        element: <AdminInfoCards />,
      },
      {
        path: 'theme',
        element: <AdminTheme />,
      },
      {
        path: 'menu',
        element: <AdminMenu />,
      },
      {
        path: 'about',
        element: <AdminAbout />,
      },
      {
        path: 'services',
        element: <AdminServices />,
      },
      {
        path: 'gallery',
        element: <AdminGallery />,
      },
      {
        path: 'blog',
        element: <AdminBlog />,
      },
      {
        path: 'contact',
        element: <AdminContact />,
      },
      {
        path: 'seo',
        element: <AdminSEO />,
      },
      {
        path: 'messages',
        element: <AdminMessages />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
